import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabaseClient';
import { useAuth } from '@/contexts/AuthContext';
import { PartnerDetails } from '@/types/partners';


export function usePartnerDetails() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['partner-details', user?.id],
    queryFn: async (): Promise<PartnerDetails | null> => {
      if (!user) throw new Error('User not authenticated');

      const { data, error } = await supabase
        .rpc('get_partner_details', { p_user_id: user.id });

      if (error) {
        // If no partner found, return null (not an error)
        if (error.code === 'PGRST116') {
          return null;
        }
        throw error;
      }

      return data?.[0] || null;
    },
    enabled: !!user,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
}
